import { useGetUsers } from "@bvhi/backend-api/apis/api/user/user";
import { BVHIErrorsAlerts } from "../../../../../../components/bvhi-error-alerts";
import { Route } from "../../../../../../routes/_main/app/users.index";

export const UsersErrorAlerts = () => {
  const searchParams = Route.useSearch();
  const { error } = useGetUsers(searchParams);

  return <BVHIErrorsAlerts error={error} />;
};
